/* Buddies mega menu - desktop panels for the vertical "SHOP HERE" menu */
(function () {
  'use strict';
  if (window.__buddiesMegaMenu) return;
  window.__buddiesMegaMenu = true;

  var OPEN_DELAY = 120;
  var CLOSE_DELAY = 300;
  var GAP = 10;
  var desktop = window.matchMedia('(min-width: 1025px)');
  var items = [];
  var current = null;

  function clearTimers(item) {
    clearTimeout(item.openTimer);
    clearTimeout(item.closeTimer);
    item.openTimer = item.closeTimer = null;
  }

  function position(item) {
    var li = item.li;
    var panel = item.panel;
    var liRect = li.getBoundingClientRect();
    var list = li.parentElement;
    var listRect = list.getBoundingClientRect();
    var container = li.closest('.vertical-menu__container') || list;
    var contRect = container.getBoundingClientRect();
    var right = document.documentElement.clientWidth - 20;
    var col = container.closest('[class*="col-"]');
    var sib = col && col.nextElementSibling;
    if (sib) {
      var sRect = sib.getBoundingClientRect();
      var pad = parseFloat(window.getComputedStyle(sib).paddingRight) || 0;
      if (sRect.width > 0) right = sRect.right - pad;
    }
    var left = contRect.right + GAP;
    var width = Math.max(520, Math.round(right - left));
    panel.style.left = Math.round(left - liRect.left) + 'px';
    panel.style.top = Math.round(listRect.top - liRect.top) + 'px';
    panel.style.width = width + 'px';
  }

  function open(item) {
    if (!desktop.matches) return;
    clearTimers(item);
    if (current && current !== item) close(current);
    position(item);
    item.li.classList.add('bmm-open');
    item.toggle.setAttribute('aria-expanded', 'true');
    current = item;
  }

  function close(item, returnFocus) {
    clearTimers(item);
    item.li.classList.remove('bmm-open');
    item.toggle.setAttribute('aria-expanded', 'false');
    if (current === item) current = null;
    if (returnFocus && item.link) item.link.focus();
  }

  function isOpen(item) {
    return item.li.classList.contains('bmm-open');
  }

  function firstTile(item) {
    return item.panel.querySelector('a[href]');
  }

  function setup(li) {
    var toggle = li.querySelector(':scope > [data-bmm-toggle]');
    var panel = li.querySelector(':scope > [data-bmm-panel]');
    if (!toggle || !panel) return;
    var item = {
      li: li,
      toggle: toggle,
      panel: panel,
      link: li.querySelector(':scope > a'),
      openTimer: null,
      closeTimer: null
    };
    li.classList.add('bmm-parent');
    items.push(item);

    li.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !desktop.matches) return;
      clearTimeout(item.closeTimer);
      if (isOpen(item)) return;
      clearTimeout(item.openTimer);
      item.openTimer = setTimeout(function () { open(item); }, OPEN_DELAY);
    });
    li.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(item.openTimer);
      if (!isOpen(item)) return;
      clearTimeout(item.closeTimer);
      item.closeTimer = setTimeout(function () { close(item); }, CLOSE_DELAY);
    });

    function onToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen(item)) {
        close(item);
      } else {
        open(item);
      }
    }
    toggle.addEventListener('click', onToggle);
    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        onToggle(e);
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        open(item);
        var t = firstTile(item);
        if (t) t.focus();
      }
    });
    if (item.link) {
      // Desktop: the parent item only opens its panel; "Shop all" inside the panel navigates
      item.link.setAttribute('aria-haspopup', 'true');
      item.link.addEventListener('click', function (e) {
        if (!desktop.matches) return;
        e.preventDefault();
        e.stopPropagation();
        open(item);
      });
      item.link.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && desktop.matches) {
          e.preventDefault();
          open(item);
          var f = firstTile(item);
          if (f) f.focus();
          return;
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          open(item);
          var t = firstTile(item);
          if (t) t.focus();
        }
      });
    }

    li.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (to && li.contains(to)) return;
      setTimeout(function () {
        if (!li.contains(document.activeElement)) close(item);
      }, 0);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.vertical-menu__items > li').forEach(function (li) {
      if (li.hasAttribute('data-bmm-ready')) return;
      li.setAttribute('data-bmm-ready', '');
      setup(li);
    });
  }

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && current) {
      var item = current;
      close(item, true);
      e.stopPropagation();
      // swallow the matching keyup so the theme's drawer handler doesn't also close SHOP HERE
      document.addEventListener('keyup', function swallow(ev) {
        if (ev.key === 'Escape' || ev.key === 'Esc') ev.stopPropagation();
        document.removeEventListener('keyup', swallow, true);
      }, true);
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (current && !current.li.contains(e.target)) close(current);
  });

  function reposition() {
    if (current) position(current);
  }
  window.addEventListener('resize', reposition);
  window.addEventListener('scroll', reposition, { passive: true });

  function onBreakpoint() {
    if (!desktop.matches && current) close(current);
  }
  if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);
  else if (desktop.addListener) desktop.addListener(onBreakpoint);

  document.addEventListener('toggle', function (e) {
    if (current && e.target && e.target.classList && e.target.classList.contains('vertical-menu') && !e.target.open) {
      close(current);
    }
  }, true);

  // Close the SHOP HERE dropdown on outside click / Escape (desktop, pages where it starts closed)
  function openShopMenu() {
    var d = document.querySelector('details.vertical-menu[open]');
    return d && !d.hasAttribute('data-menu-opened') ? d : null;
  }
  function closeShopMenu(d) {
    if (current) close(current);
    var summary = d.querySelector(':scope > summary');
    if (summary) summary.click(); else d.removeAttribute('open');
  }
  document.addEventListener('click', function (e) {
    if (!desktop.matches) return;
    var d = openShopMenu();
    if (d && !d.contains(e.target)) closeShopMenu(d);
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && !current && desktop.matches) {
      var d = openShopMenu();
      if (d) {
        closeShopMenu(d);
        var s = d.querySelector(':scope > summary');
        if (s) s.focus();
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
